module.exports = __webpack_public_path__ + "img/egg.ad948f39.jpg";